import { supabase } from "../supabaseClient";

/**
 * Records an application action that cannot be captured by a database row
 * trigger, such as viewing a record or signing out.
 *
 * Audit failures are deliberately non-blocking: the user's requested action
 * should continue, while the failure remains visible in development tools.
 */
export async function recordApplicationAudit({
  action,
  tableName = null,
  recordId = null,
  summary = null,
  metadata = {},
}) {
  try {
    const { error } = await supabase.rpc("write_application_audit_event", {
      p_action: action,
      p_table_name: tableName,
      p_record_id: recordId == null ? null : String(recordId),
      p_summary: summary,
      p_metadata: metadata,
    });

    if (error) {
      console.warn("Audit event could not be recorded:", error.message);
      return false;
    }

    return true;
  } catch (error) {
    console.warn("Audit event could not be recorded:", error);
    return false;
  }
}

export async function signOutWithAudit() {
  await recordApplicationAudit({
    action: "LOGOUT",
    tableName: "users",
    summary: "User signed out",
    metadata: {
      path: window.location.pathname,
      user_agent: window.navigator.userAgent,
    },
  });

  return supabase.auth.signOut();
}
